import { Link } from "react-router-dom";
import Taskbar from '../components/Taskbar'; 
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";

const About = () => {
  return (
    <>
      <Taskbar />
<TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-12 min-[942px]:mt-[51px] bg-card">
        <section
          className="p-2 shadow-theme transition-colors duration-500"
          aria-label="About Church Notes"
          style={{ animation: "fadeIn 1.5s ease forwards" }}
        >
          <h1 className="text-4xl font-extrabold mb-2 border-b-4 border-border text-center text-secondary">
            About Our Church
          </h1>

          <h2 className="text-2xl font-bold mb-2 pb-1 text-add">
            Mission Statement
          </h2>
          <p className="text-text mb-4 font-bold">
            Take souls from darkness into the Light, keep them in the Light and teach them how to walk in the Light.
          </p>

          <h2 className="text-2xl font-bold mb-2 pb-1 text-add">
            Vision
          </h2>
          <p className="text-text font-bold mb-4">
            Establishing the Kingdom, the Power and the Glory of God in the Lives of Men.
          </p>

          <h2 className="text-2xl font-bold mb-2 pb-1 text-add">
            What We Believe
          </h2>
          <ul className="list-disc list-inside mb-2 space-y-4 font-bold text-text">
            <li>We believe there is one true God whose name is Yahweh [John 17:3, Psalms 83:18]. We believe that Jesus is the Lord and Christ [Acts 2:36].</li>
            <li>We believe that we are saved by grace through faith in the name of Jesus Christ [Ephesians 2:8, Acts 4:10-12].</li>
            <li>We believe that the Holy Spirit is the Gift of God we receive by faith after repentance [Acts 2:38].</li>
            <li>We believe in forgiveness of sins in Christ, and righteousness in Him [Colossians 1:14, 2 Corinthians 5:21].</li>
            <li>We believe that Jesus is coming again to judge the world [Acts 1:11, Revelation 21:20].</li>
            <li>We believe in free will and the choice of eternity [Luke 16:19-13].</li>
            <li>We believe the Bible is inspired by the Holy Spirit [2 Timothy 3:15].</li>
            <li>We believe God speaks through His servants with signs, wonders, and miracles [Acts 5:12-14].</li>
            <li>We believe prayer is a responsibility for sustaining fellowship with Christ [Luke 11:8-1].</li>
          </ul>

          <h2 className="text-2xl font-bold mb-2 pb-1 text-add">
            Our Revelation Of God
          </h2>
          <ul className="list-disc list-inside mb-6 space-y-2 font-bold text-text">
            <li>The way God manifests Himself depends on how He revealed Himself to His prophet.</li>
            <li>God revealed Himself to Prophet Kelvin as the "GOD OF ALL GRACE" [1 Peter 5:10].</li>
            <li>We worship and serve the God of all grace, the God with whom nothing is impossible.</li>
          </ul>

          <h2 className="text-2xl font-bold mb-2 pb-1 text-add">
            Our Leadership
          </h2>
          <ul className="list-disc list-inside mb-6 space-y-2 font-bold text-text">
            <li>A.G.M is under the leadership of the Holy Spirit, Prophet Kelvin, and Rev Karen [Acts 20:28].</li>
            <li>The board oversees all Apostolic Gospel Mission assemblies worldwide according to the will of the Lord.</li>
          </ul>

          <h2 className="text-2xl font-bold mb-2 pb-1 text-add">
            Join Us
          </h2>
          <p className="text-text font-bold mb-4">
            Whether you're new to faith or looking for a church family, join us every Sunday on 
            [<Link to="/Live-tv" className="font-bold border-b hover:border-border text-primary hover:text-secondary ml-1">
              Live Tv Broadcast 
            </Link> ]
            for vibrant worship and life-changing teaching.
          </p>
        </section>

        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default About;
